export const locale = {
    lang: 'en',
    data: {
        'SAMPLE': {
            'MAINTENANCE': 'Environment under Maintenance'
        }
    }
};
